/**
 * GitHub issue comments have no threading, so a reply written in cubic ends with a footer that
 * names the parent comment.
 */

/**
 * Matches the auto-appended “Replied in …” footer and captures the parent comment identifier.
 */
export const REPLY_FOOTER_REGEX =
  /(?:\r?\n)*---(?:\r?\n)*Replied in \[(?:mrge\.io|cubic\.dev)\]\(https:\/\/(?:www\.)?(?:mrge\.io|cubic\.dev)(?:\/[^)?]*)?\?parent=([^)]+)\)\s*$/;

export function formatIssueReplyBody(content: string, parentId: string): string {
  const trimmedContent = removeReplyFooter(content);
  const replyFooter = `Replied in [cubic.dev](https://www.cubic.dev?parent=${parentId})`;
  return `${trimmedContent}\n\n---\n\n${replyFooter}`;
}

export function removeReplyFooter(content: string): string {
  return content.replace(REPLY_FOOTER_REGEX, '').trim();
}
